import styled from "@emotion/native";
import { Animated } from "react-native";
import Text from "../Text";

export const Container = styled(Animated.View)(
	{
		padding: 20,
		paddingRight: 13,
		paddingBottom: 35,
	},
	({ theme }: any) => {
		return {
			backgroundColor: theme.color.backgroundAccent,
		};
	}
);

export const Body = styled(Text)({
	marginBottom: 17,
});

export const Author = styled(Text)({
	marginBottom: 2,
});
